import { render, staticRenderFns } from "./svanLoading.vue?vue&type=template&id=525b32eb"
import script from "./svanLoading.vue?vue&type=script&lang=js"
export * from "./svanLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports